import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { MapPinIcon } from 'lucide-react';
import { Badge } from '../../Badge';
export function AboutHero() {
  const reduce = useReducedMotion();
  return <section id="about-top" className="relative w-full overflow-hidden bg-deep-navy" style={{
    backgroundColor: '#0F4C81'
  }} data-id="element-25" data-mp="y6byry8dnz25">
      {/* solid-color glow blobs (no multi-color gradients) */}
      <div className="pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-26" data-mp="1qt6gindt8kbx">
        <div className="absolute -left-24 top-8 h-72 w-72 rounded-full bg-sky-blue opacity-20 blur-3xl" data-id="element-27" data-mp="1lw6a2bd1tfka" />
        <div className="absolute bottom-0 right-1/4 h-64 w-64 rounded-full bg-sage-green opacity-10 blur-3xl" data-id="element-28" data-mp="1hrq4kb7cka5l" />
      </div>

      <div className="relative mx-auto max-w-4xl px-4 py-20 text-center sm:px-6 sm:py-28" data-id="element-29" data-mp="1cwarvml2skar">
        <motion.div initial={reduce ? undefined : {
        opacity: 0,
        y: 16
      }} whileInView={reduce ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-30" data-mp="6ffhmlfab892">
          <div className="flex justify-center" data-id="element-31" data-mp="2oqi0kizplmti">
            <Badge variant="sky" style={{
            color: '#74A7C9',
            backgroundColor: 'rgba(116, 167, 201, 0.15)',
            borderColor: 'rgba(116, 167, 201, 0.3)'
          }} className="border" data-id="element-32" data-mp="2a2wymsekltn6">
              会社概要
            </Badge>
          </div>
          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-5xl" data-id="element-33" data-mp="254ve031hxm9l">
            横須賀の中小企業に、
            <br className="hidden sm:block" data-id="element-34" data-mp="1w3ntcnrwkjxz" />
            本業へ集中できる時間を。
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-35" data-mp="1w5qkxc8pel4t">
            OptiDSA（Opti Digital Services
            Agency）は、地域の中小企業のための伴走型デジタルパートナーです。
            既製品を売るのではなく、あなたの現場に本当に合うサービスを一緒に選び、導入から運用まで並走します。
          </p>
          <p className="mt-6 inline-flex items-center gap-2 text-sm text-white/70" data-id="element-36" data-mp="3p1b0kh7561ul">
            <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-37" data-mp="3k2hjyfwk5uq7" />
            神奈川県横須賀市
          </p>
        </motion.div>
      </div>
    </section>;
}